import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Checkbox, Pill, Tooltip } from '@dsny/dsny-component-library';
import theme from 'src/styles/theme';
import { Close, Download } from '@dsny/dsny-component-library/icons';
import {
  ActionBarWrapper,
  CheckboxStyles,
  CloseButtondWrapperDesktop,
  CloseButtondWrapperMobile,
  IconContainerStyles,
  PillStyles,
  SelectedSongsStyle,
  SongsSelectedWrapper,
  TooltipContainerStyles,
  VerticalLine,
} from './ActionBar.styles';

interface ActionBarProps {
  selectedRows: string[];
  isAllItemsSelected: boolean;
  noDataToExportToolTip: boolean;
  exportCSV: (songIds: string[]) => void;
  setRowSelection: (
    selection:
      | Record<number, boolean>
      | ((selection: Record<number, boolean>) => Record<number, boolean>)
  ) => void;
  setSearchRowSelectionIds: React.Dispatch<React.SetStateAction<string[]>>;
  setRowSelectionIds: React.Dispatch<React.SetStateAction<string[]>>;
}

const ActionBar: React.FC<ActionBarProps> = ({
  selectedRows,
  isAllItemsSelected,
  noDataToExportToolTip,
  exportCSV,
  setRowSelection,
  setSearchRowSelectionIds,
  setRowSelectionIds,
}) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);

  // Export CSV data
  const handleExportCSV = () => {
    exportCSV(selectedRows);
  };

  // Close action bar
  const closeActionBar = () => {
    setIsVisible(false);
    setSearchRowSelectionIds([]);
    setRowSelectionIds([]);
    setRowSelection({});
  };

  // Getting export button
  const getExportButton = () => {
    return (
      <Pill
        label={t('LIBRARY_EXPORT_CSV_LABEL')}
        onClick={handleExportCSV}
        variant="tonal"
        iconPosition="leading"
        icon={<Download />}
        iconContainerStyles={{ ...IconContainerStyles }}
        style={{ ...PillStyles }}
      />
    );
  };

  useEffect(() => {
    if (selectedRows.length > 0) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [selectedRows]);

  return (
    <>
      {/*  Action bar */}
      {isVisible && (
        <ActionBarWrapper>
          {/* Selected song(s) */}
          <SongsSelectedWrapper>
            <Checkbox
              id="checkValue"
              name="checkValue"
              color={theme.colors.green}
              onClick={closeActionBar}
              value=""
              checked={isAllItemsSelected ? true : 'mixed'}
              style={{ ...CheckboxStyles }}
              disabled={false}
            />
            <SelectedSongsStyle>
              <Trans
                i18nKey="LIBRARY_NUMBER_OF_SELECTED_SONGS"
                values={{
                  number: selectedRows.length,
                }}
              />
            </SelectedSongsStyle>

            {/* Close button - Mobile view */}
            <CloseButtondWrapperMobile onClick={closeActionBar}>
              <Close />
            </CloseButtondWrapperMobile>
          </SongsSelectedWrapper>

          {/* Separator */}
          <VerticalLine />

          {/* Export CSV */}
          {/* Display tooltip and pill if any “0 spins” songs are selected otherwise only the pill */}
          {noDataToExportToolTip ? (
            <Tooltip
              text={t('LIBRARY_EXPORT_CSV_TOOLTIP')}
              placement="top"
              color={theme.colors.white}
              backgroundColor={theme.colors.neutralW50}
              hasArrow={false}
              containerStyles={{ ...TooltipContainerStyles }}
            >
              {getExportButton()}
            </Tooltip>
          ) : (
            getExportButton()
          )}

          {/* Close button - Desktop view */}
          <CloseButtondWrapperDesktop onClick={closeActionBar}>
            <Close />
          </CloseButtondWrapperDesktop>
        </ActionBarWrapper>
      )}
    </>
  );
};

export default ActionBar;
